import { TYPE_CHANGE_LANGUAGE } from '../reducers/translation';

const changeLanguage = (language: any) => (dispatch: any) => {
    dispatch({ type: TYPE_CHANGE_LANGUAGE, data: language });
};
export default changeLanguage;
